import { ImageProps } from "@lib/image";
import { MDXRemoteSerializeResult } from "next-mdx-remote";
import { StrapiMediaDTO } from "@lib/strapi/dtos/core/media.dto";
import {
  StrapiSEODTO,
  SEODTO,
} from "@lib/strapi/dtos/components/shared/sEO.dto";
import {
  StrapiTreatmentDTO,
  TreatmentDTO,
} from "@lib/strapi/dtos/content-types/treatment.dto";

export class StrapiConditionDTO {
  constructor() {}

  title: string;
  slug: string;
  teaser: string;
  description: string;
  symptoms: string;
  sortIndex: number;
  coverImage: StrapiMediaDTO;
  treatments: StrapiTreatmentDTO[];
  seo: StrapiSEODTO;
}

export class ConditionDTO {
  constructor() {}

  extraData: any = {};
  title: string;
  slug: string;
  teaser: string;
  description: MDXRemoteSerializeResult;
  symptoms: MDXRemoteSerializeResult;
  sortIndex: number;
  coverImage: ImageProps;
  treatments: TreatmentDTO[];
  seo: SEODTO;
}
